module.exports = {"210522001":"八卦城街道","210522100":"桓仁镇","210522101":"普乐堡镇","210522102":"二棚甸子镇","210522103":"沙尖子镇","210522104":"五里甸子镇","210522108":"八里甸子镇","210522110":"华来镇","210522111":"古城镇","210522201":"雅河朝鲜族乡","210522202":"向阳乡","210522206":"黑沟乡","210522208":"北甸子乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210522.json
// module id = 544
// module chunks = 0